import {firtsElorValue, MenuItem} from 'utils';
import styles from './Menu.module.scss';
import {MenuItemLink} from './MenuLink';
import {useState} from 'react';
import {MenuOpenButton} from '@ui/MenuOpenButton/MenuOpenButton';

type MobileMenuProps = {menuItems: MenuItem[]; wellId?: string};

export const MobileMenu = ({menuItems, wellId}: MobileMenuProps) => {
    const [isOpen, setIsOpen] = useState(false);
    const onItemClick = () => {
        setIsOpen(false);
    };

    const handleOpenClick = () => {
        setIsOpen((prev) => !prev);
    };
    return (
        <section
            className={styles.mobileWrapper}
            id='menu-section'
        >
            <MenuOpenButton
                handleOpenClick={handleOpenClick}
                isOpen={isOpen}
            />
            {menuItems.map((menuItem) => (
                <MenuItemLink
                    key={menuItem.pathCode || firtsElorValue(menuItem.key)}
                    item={menuItem}
                    wellId={wellId ?? ''}
                    onItemClick={onItemClick}
                    isMobile
                    showTitle={isOpen}
                />
            ))}
        </section>
    );
};
